import "./rooms.css";

import React from "react";
import { Link } from "react-router-dom";

import { ANCHORS, BOOKING_LINK, ROOMS, ROUTES } from "../../data/content";
import { BedIcon, GuestsIcon, RoomSizeIcon } from "../general/Icons";
import PageMeta from "../general/PageMeta";
import { PageHero } from "../general/PageSections";

const RoomType = ({ room }) => (
  <React.Fragment>
    <section
      id={room.slug}
      className={"room"}
      aria-labelledby={`${room.slug}-title`}
    >
      <div className={"container"}>
        <h2
          id={`${room.slug}-title`}
          className={"heading is-display"}
        >
          {room.title}
        </h2>
        <p className={"body-text room-text"}>{room.text}</p>

        <h3 className={"room-amenities-title"}>AMENITIES</h3>
        <div className={"room-box"}>
          <ul className={"room-amenities"}>
            {room.amenities.map((amenity) => (
              <li key={amenity}>{amenity}</li>
            ))}
          </ul>
          <ul className={"room-facts"}>
            <li>
              <RoomSizeIcon />
              <span className={"room-fact-label"}>Room Size</span>
              <span className={"room-fact-value"}>{room.size}</span>
            </li>
            <li>
              <BedIcon />
              <span className={"room-fact-label"}>Bedding</span>
              <span className={"room-fact-value"}>{room.bedding}</span>
            </li>
            <li>
              <GuestsIcon />
              <span className={"room-fact-label"}>Room Capacity</span>
              <span className={"room-fact-value"}>{room.capacity}</span>
            </li>
          </ul>
        </div>

        <div className={"room-book"}>
          <a
            href={BOOKING_LINK}
            className={"btn"}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            Book Your Stay
          </a>
        </div>
      </div>
    </section>

    <div className={"room-photos"}>
      {room.photos.map((photo) => (
        <img
          key={photo.src}
          src={photo.src}
          alt={photo.alt}
          width={1000}
          height={667}
          loading={"lazy"}
        />
      ))}
    </div>
  </React.Fragment>
);

const Rooms = () => {
  return (
    <React.Fragment>
      <PageMeta
        title={ROOMS.TITLE}
        description={ROOMS.DESCRIPTION}
      />
      <PageHero src={"/images/rooms/towels.webp"} />

      <section className={"title-band rooms-intro"}>
        <h1 className={"title-band-title"}>{ROOMS.TITLE}</h1>
        <p className={"rooms-intro-text"}>{ROOMS.INTRO}</p>
        <ul className={"rooms-summary"}>
          {ROOMS.SUMMARY.map((type) => (
            <li key={type.slug}>
              <Link to={`${ROUTES.ROOMS}#${type.slug}`}>
                <span className={"rooms-summary-name"}>{type.name}</span>
                <span className={"rooms-summary-count"}>{type.count}</span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      {ROOMS.TYPES.map((room) => (
        <RoomType
          key={room.slug}
          room={room}
        />
      ))}

      <section className={"room rooms-groups"}>
        <div className={"container"}>
          <h2 className={"heading is-display"}>{ROOMS.GROUPS_TITLE}</h2>
          <ul className={"rooms-groups-list"}>
            {ROOMS.GROUPS.map((group) => (
              <li key={group}>{group}</li>
            ))}
          </ul>
          <div className={"room-book"}>
            {/* Went to the top of the Contact page on Wix - now straight to the group booking form */}
            <Link
              to={`${ROUTES.CONTACT}#${ANCHORS.GROUP_BOOKING}`}
              className={"btn"}
            >
              {ROOMS.GROUPS_BUTTON}
            </Link>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Rooms;
